import React from "react";
import Box from "../component/Box/Box";
import PropTypes from "prop-types";
import Notify from "../services/Notify";
import Loading from "../component/Loading/Loading";
import {Col, ControlLabel, FormGroup, Row} from "react-bootstrap";
import CheckpointService from "./CheckpointService";
import CheckpointTypeSelector from "./CheckpointTypeSelector";
import BizLocationSelector from "../component/BizLocation/BizLocationSelector";
import DispositionSelector from "../disposition/DispositionSelector";
import BizStepSelector from "../component/BizStep/BizStepSelector";
import CheckpointIntegrationForm from "./integration/CheckpointIntegrationForm";
import FormButtons from "../component/Form/FormButtons";
import Objects from "../utils/Objects";
import CheckboxWithLabel from "../component/Checkbox/CheckBoxWithLabel";

class CheckpointForm extends React.Component {

    checkpointService = new CheckpointService();

    constructor(props) {
        super(props);
        this.state = {loading: false, validateFlow: false};
    }

    componentWillMount() {
        const {match} = this.props;
        const id = match.params.id;
        if (id) {
            this.setState({loading: true});
            this.checkpointService.findById(id).then(
                data => {
                    const haveValidateFlow = (data.allowedDispositions && data.allowedDispositions.length > 0 || data.allowedSteps && data.allowedSteps.length > 0)

                    this.setState({
                        loading: false,
                        entity: data,
                        canDoMobileOperation: data.canDoMobileOperation,
                        isIntegrated: data.isIntegrated,
                        validateFlow: haveValidateFlow
                    })
                },
                error => {
                    const state = {loading: false};
                    if (error.response.status === 404) {
                        state.message = 'Entidade não encontrada!';
                    } else {
                        state.message = 'Erro inesperado!';
                        Notify.error('Falha o buscar entidade!', error)
                    }
                    this.setState(state);
                }
            )
        }
    }

    submitForm() {
        const {entity = {lsd: {}}, validateFlow, canDoMobileOperation} = this.state;
        const {integrationType, isIntegrated, params} = this.integrationObject || {};

        entity.friendlyName = this.friendlyName.value.trim();
        entity.description = this.description.value;
        entity.type = this.type;
        entity.isIntegrated = isIntegrated;
        entity.integrationType = isIntegrated ? integrationType : null;
        entity.integrationParams = params;
        entity.canDoMobileOperation = canDoMobileOperation
        entity.allowedDispositions = validateFlow ? this.allowedDispositions : []
        entity.allowedSteps = validateFlow ? this.allowedSteps : []
        entity.lsd.bizLocation = Objects.nonNull(this.bizLocationId) ? {id: this.bizLocationId} : {id: this.state.entity.lsd.bizLocation.id}
        entity.lsd.disposition = Objects.nonNull(this.dispositionId) ? {id: this.dispositionId} : {id: this.state.entity.lsd.disposition.id}
        entity.lsd.bizStep = Objects.nonNull(this.bizStepId) ? {id: this.bizStepId} : {id: this.state.entity.lsd.bizStep.id}

        this.setState({loading: true, message: 'Salvando...'});
        this.checkpointService.save(entity).then(
            (data) => {
                if (entity.id) {
                    this.props.history.goBack();
                } else {
                    this.props.history.push(`/checkpoints/${data.id}/profiles`);
                }
                Notify.success('Entidade salva');
            },
            (error) => {
                Notify.error('Falha ao salvar entidade:', error);
                this.setState({loading: false, message: null});
            });
    }

    render() {
        const {loading, entity = {}, message, validateFlow} = this.state;

        if (loading) {
            return <Loading message={message}/>
        }

        if (message) {
            return <h2>{message}</h2>
        }

        return (
            <Box info>
                <form ref={form => (this.form = form)} onSubmit={event => {
                    event.preventDefault();
                    this.submitForm()
                }}>

                    <FormGroup>
                        <ControlLabel>Nome</ControlLabel>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nome"
                            required
                            name="friendlyName"
                            ref={friendlyName => this.friendlyName = friendlyName}
                            defaultValue={entity && entity.friendlyName}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Descrição</ControlLabel>
                        <input
                            type="text"
                            className="form-control"
                            name="description"
                            ref={value => this.description = value}
                            defaultValue={entity && entity.description}
                        />
                    </FormGroup>

                    <CheckpointIntegrationForm defaultValue={entity}
                                               setValue={integrationObject => this.integrationObject = integrationObject}/>

                    <FormGroup className="w-100 mt-4">
                        <Row>
                            <Col md={4}>
                                <CheckboxWithLabel
                                    label="Permite operações no Mobile"
                                    defaultValue={entity.canDoMobileOperation}
                                    setValue={e => this.setState({canDoMobileOperation: e.target.checked})}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxWithLabel
                                    label="Executar validação de fluxo"
                                    defaultValue={validateFlow}
                                    setValue={e => this.setState({validateFlow: !validateFlow})}
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    <CheckpointTypeSelector required={true}
                                            defaultValue={entity && entity.type}
                                            setValue={value => this.type = value}/>

                    <BizLocationSelector
                        defaultValue={entity.lsd && entity.lsd.bizLocation}
                        setValue={bizLocationId => this.bizLocationId = bizLocationId}/>

                    <Row className="d-flex align-items-end">
                        <Col md={6}>
                            <DispositionSelector
                                title="Disposição que o item receberá ao ser processado neste ponto de controle"
                                openToTop
                                defaultValue={entity.lsd && entity.lsd.disposition && entity.lsd.disposition.id}
                                setValue={dispositionId => this.dispositionId = dispositionId}/>
                        </Col>
                        <Col md={6}>
                            <BizStepSelector
                                title="Etapas do processo do ponto de controle"
                                openToTop
                                defaultValue={entity.lsd && entity.lsd.bizStep && entity.lsd.bizStep.id}
                                setValue={bizStepId => this.bizStepId = bizStepId}/>
                        </Col>
                        <Col md={6}>
                            <DispositionSelector
                                multiple
                                hide={!validateFlow}
                                openToTop
                                title="Disposição anteriores do item que são aceitas neste ponto de controle"
                                defaultValue={entity && entity.allowedDispositions}
                                setValue={allowedDispositions => this.allowedDispositions = allowedDispositions}/>
                        </Col>
                        <Col md={6}>
                            <BizStepSelector
                                multiple
                                hide={!validateFlow}
                                openToTop
                                title="Etapas anteriores do item que são aceitas neste ponto de controle"
                                defaultValue={entity && entity.allowedSteps}
                                setValue={allowedSteps => this.allowedSteps = allowedSteps}/>
                        </Col>
                    </Row>
                    <FormButtons history={this.props.history}/>
                </form>
            </Box>
        );
    }
}

CheckpointForm.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default CheckpointForm;



// WEBPACK FOOTER //
// ./src/checkpoint/CheckpointForm.js